<div class="container-fluid m-0 p-0" style="min-height: 844px; justify-content: center;">
    <div class="row caja" *ngIf="dataCompania && dataCompania.length > 0">
        <div class="col-8 analisis-panel">
            <h3>Sobre la Compañia</h3>
            <p>{{dataCompania[0].description}}</p>
        </div>
        <div class="col-4 enlace">
            <p>Industria: <strong>{{dataCompania[0].industry}}</strong></p>
            <p><a href="{{dataCompania[0].website}}" target="_blank" rel="noopener noreferrer">{{dataCompania[0].website}}</a></p>
            
            <img src="{{dataCompania[0].image}}" alt="">
        </div>
    </div>
</div>